import { inject, Injectable, signal } from '@angular/core';
import { LocalStorageService } from '../services/LocalStorageService';
import { ILanguage } from '../interfaces/ILanguage';
import { toObservable } from '@angular/core/rxjs-interop';
import { ILanguageConfig } from '../interfaces/ILanguageConfig';

@Injectable({
  providedIn: 'root'
})
export class LanguageStore {

  private readonly _localStorageService = inject(LocalStorageService);

  public static instance: LanguageStore;
  public readonly language = signal<ILanguage>(this._localStorageService.getItem('user-lang'));
  public readonly languageConfig = signal<ILanguageConfig>(null);
  public readonly languages = signal<ILanguage[]>(null);

  public constructor() {
    LanguageStore.instance = this;

    toObservable(
      this.language
    ).subscribe(language => {
      if (language) {
        this._localStorageService.setItem('user-lang', language);
      }
    });
  }
}
